import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { publicApi } from '../services/api';

const TenantContext = createContext({
  loading: true,
  platform: false,
  agent: null,
  pathTenantRoutesEnabled: false,
  listingsLive: false,
  listingsConnecting: false,
  listingsConnectingWording: '',
  hostname: null,
});

export function TenantProvider({ children }) {
  const [state, setState] = useState({
    loading: true,
    platform: false,
    agent: null,
    pathTenantRoutesEnabled: false,
    listingsLive: false,
    listingsConnecting: false,
    listingsConnectingWording: '',
    hostname: null,
  });

  useEffect(() => {
    let cancelled = false;
    publicApi.get('/auth/tenant')
      .then((res) => {
        if (cancelled) return;
        const data = res.data || {};
        setState({
          loading: false,
          platform: data.platform !== false && !data.agent,
          agent: data.agent || null,
          pathTenantRoutesEnabled: Boolean(data.pathTenantRoutesEnabled),
          listingsLive: Boolean(data.listingsLive),
          listingsConnecting: Boolean(data.listingsConnecting),
          listingsConnectingWording: data.listingsConnectingWording || '',
          hostname: data.hostname || null,
        });
      })
      .catch(() => {
        if (cancelled) return;
        setState((prev) => ({ ...prev, loading: false, platform: true, agent: null }));
      });
    return () => { cancelled = true; };
  }, []);

  const value = useMemo(() => state, [state]);
  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
}

export function useTenant() {
  return useContext(TenantContext);
}
